module.exports = __webpack_public_path__ + "static/img/top-promotion.adf8007.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/header/top-promotion.gif
// module id = 8aSP
// module chunks = 1 2